import React from "react";
import { Icon } from "@telia/teddy";

interface Props {
    onClick: () => void;
}

const ExtraSimButton: React.FC<Props> = ({ onClick }) => {
    return (
        <button className="choose-sim-card__extra-sim-button" onClick={onClick}>
            <Icon name="plus" />
            <div className="choose-sim-card__extra-sim-button-description">
                <div className="choose-sim-card__extra-sim-button-title">Legg til ekstra SIM</div>
                <div className="choose-sim-card__extra-sim-button-subtitle">DataSIM eller TvillingSIM</div>
            </div>
        </button>
    );
};

export default ExtraSimButton;
